import { useEffect, useRef, useState } from 'react';
import { H3, H4 } from '../../styles/FontStyles';
import {
  ArrowChevron,
  Button,
  Collapsable,
  Flexed
} from '../../styles/GlobalComponents';

import { CaptionText, P1, P3 } from '../../styles/FontStyles';
import { color } from '../../styles/GlobalStyles';
import {
  Icon,
  IconPortfolioOrders,
  IconTotalModeOff,
  IconTotalModeOn,
  IconTravelPackages
} from '../../styles/Icons';
import { BoxPortfolio, SummaryGrid } from './Portfolio.styled';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { useAppSelector } from '../../app/hooks';
import { formatUSD } from '../../helpers/helperFunctions';
import { getMyHubsAkasha } from './Portfolio.actions';
import { AKASHA, TRAVEL_PACKAGES } from '../../routes/routes';
import Spinner from '../../components/common/Spinner';
import { PortfolioTravelItem } from './PortfolioTravelItem';
import { PortfolioAkashaItem } from './PortfolioAkashaItem';

export const AkashaSummary = () => {
  const dispatch = useDispatch();

  const ref = useRef<any>(null);
  const [expanded, setExpanded] = useState(true);
  const history = useHistory();
  const [height, setHeight] = useState(ref?.current?.clientHeight);
  const { akashaPackages, loadingSummary } = useAppSelector(
    (state) => state.portfolio
  );
  const { canBuyAkashaPackages } = useAppSelector(
    (state) => state.auth.userInfo
  );

  useEffect(() => {
    dispatch(getMyHubsAkasha());
  }, [dispatch]);

  return (
    <div style={{ marginBottom: 40 }}>
      <Flexed mb='20' center between>
        <H3>My Super Nodes summary</H3>
      </Flexed>

      <SummaryGrid>
        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioOrders />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              Total Orders
            </CaptionText>

            <P1 bold flex alignEnd gap='5px'>
              {formatUSD(akashaPackages?.summary?.totalOrderAmount)}
              <P3 mb='1'>USDT</P3>
            </P1>
          </div>
        </BoxPortfolio>

        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconTotalModeOn />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              Total node on
            </CaptionText>
            <P1 bold flex alignEnd gap='5px'>
              {formatUSD(akashaPackages?.summary?.totalNodeDepositOn)}
            </P1>
          </div>
        </BoxPortfolio>

        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconTotalModeOff />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              Total node off
            </CaptionText>
            <P1 bold flex alignEnd gap='5px'>
              {formatUSD(akashaPackages?.summary?.totalNodeDepositOff)}
            </P1>
          </div>
        </BoxPortfolio>
      </SummaryGrid>

      <div style={{ position: 'relative' }}>
        {loadingSummary && <Spinner absolute transparent />}
      </div>

      <Flexed center between wrap>
        <Flexed
          mb='20'
          center
          gap='20px'
          pointer
          onClick={() => setExpanded(!expanded)}>
          <H4>My Super Nodes</H4>
          <ArrowChevron direction={expanded ? 'up' : 'down'} />
        </Flexed>

        {canBuyAkashaPackages && (
          <Button
            negative
            maxWidth='350px'
            maxWidthSM='100%'
            onClick={() => history.push(AKASHA)}>
            ADD MORE NODES
          </Button>
        )}
      </Flexed>

      <Collapsable expanded={expanded} elementHeight={height}>
        <div ref={ref}>
          {akashaPackages?.userPackages?.map((item: any, i: number) => (
            <PortfolioAkashaItem key={i} item={item} />
          ))}
        </div>
      </Collapsable>
    </div>
  );
};
